import React from "react";

function MapColumn({
  selectedBackgroundIndex,
  backgrounds,
  setBackgroundIndex,
  debugLayout = false,
}) {
  return (
    <table style={debugLayout ? { border: "1px solid #ddd" } : {}} border={debugLayout ? 1 : 0}>
      <tbody>
        <tr>
          <td
            style={{
              textAlign: "center",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            <h5
              style={{
                textAlign: "center",
                margin: "4px",
              }}
            >
              <b>Karte</b>
            </h5>
          </td>
        </tr>
        <tr style={{ height: "100%" }}>
          <td
            key={"bgprev" + selectedBackgroundIndex}
            style={{
              textAlign: "center",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            {backgrounds.map((item, index) => {
              let style;
              if (selectedBackgroundIndex === index) {
                style = {
                  border: "3px solid #5f83b8",
                  marginLeft: 7,
                };
              } else {
                style = {
                  //border: '3px solid #818180',
                  marginLeft: 7,
                };
              }
              return (
                <a
                  key={"backgroundChanger." + index}
                  title={item.title}
                  onClick={() => {
                    setBackgroundIndex(index);
                  }}
                >
                  <img alt="" style={style} width="36px" src={item.src} />
                </a>
              );
            })}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default MapColumn;
